import React, { useState, Fragment, useEffect, useRef } from 'react';
import { Listbox, Transition, Dialog } from '@headlessui/react';
import { CheckIcon, ArrowDownIcon, DocumentArrowUpIcon } from '@heroicons/react/24/solid';
import { useTheme } from '../ThemeContext';
import ProjectNames from './Dropdowns/ProjectNames';
import { addRFI } from '../api/api';
import { toast } from 'react-toastify'
const RFIForm = ({ addModalSetting, handlePageUpdate }) => {
  const { theme } = useTheme();
  const [pname, setPname] = useState('');
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(true);
  const [rfiData, setRfiData] = useState({
    documentReference: '',
    clarificationRequested: '',
    reasonForRFI: '',
    suggestedSolution: '',
    requiredResponseDate: '',
    attachment: '',
  });

  const document = [
    { id: 0, name: 'Select' },
    { _id: '1', name: 'Site Plan', version: '2' },
    { _id: '2', name: 'Electrical Layout', version: '3' },
    { _id: '3', name: 'Plumbing Diagram', version: '1' },
  ];
  const [status, setStatus] = useState('Started');
  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  }
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setRfiData({
      ...rfiData,
      [e.target.name]: e.target.value,
    });
  };

  const [selectedFileName, setSelectedFileName] = useState("");


  const handleFileChange = (e) => {
    const file = e.target.files[0];

    setRfiData({
      ...rfiData,
      attachment: e.target.files[0],
    });
    if (file) {
      setSelectedFileName(file.name);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      document_refrence: selectedDocument,
      clarification_requested: rfiData.clarificationRequested,
      reason_for_rfi: rfiData.reasonForRFI,
      suggested_solution: rfiData.suggestedSolution,
      required_response_date: rfiData.requiredResponseDate,
      attachment: rfiData.attachment,
      project_id: pname,
    };
    setLoading(true);
    const res = await addRFI(data);
    
    addModalSetting()
    handlePageUpdate();
    console.log(res.data);
    toast.success('RFI submitted successfully!');
    setLoading(false);
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <div className={`p-6 ${theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-white text-black mt-5'} shadow-lg rounded-md m-4`}>
                <h2 className="text-2xl font-bold mb-6 text-center">Submit Request for Information (RFI)</h2>
                <p className="mb-6 text-sm text-center text-gray-600">Please fill out the form below to submit your request for information. Ensure all required fields are completed.</p>
                {message && <p className="mb-6 text-green-600 text-center">{message}</p>}
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
                    <div>
                      <ProjectNames pname={pname} handleChange={e => setPname(e.target.value)} />
                    </div>

                    <div>
                      <label className="block text-sm font-medium mb-3">Document Reference</label>
                      <select
                        value={selectedDocument || ""} onChange={e => setSelectedDocument(e.target.value)}
                        className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}>
                        <option value="">Select</option>
                        {document.filter(doc => doc.id !== 0).map((doc) =>
                          <option key={doc._id} value={doc.name}>{doc.name}</option>
                        )}
                      </select>
                    </div>

                    <div>
                      <label htmlFor="status" className="block text-sm font-medium mb-2">
                        Status
                      </label>
                      <select
                        id="status"
                        name="status"
                        value={status}
                        onChange={handleStatusChange}
                        className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}>
                        <option value="Started">Started</option>
                        <option value="Phase 1">Phase 1</option>
                        <option value="Phase 2">Phase 2</option>
                        <option value="Phase 3">Phase 3</option>
                        <option value="Completed">Completed</option>

                      </select>

                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-3 text-gray-200">Attachment</label>
                      <div className="flex items-center gap-4">
                        <label
                          htmlFor="fileInput"
                          className={` w-full flex items-center justify-start gap-2 p-2 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-300' : ''}`}>


                          {selectedFileName ? (

                            <span className="text-md text-gray-600 truncate  max-w-md">{selectedFileName}</span>


                          ) : (<><DocumentArrowUpIcon className="h-6 w-5" /><span>Upload File</span>  </>)}
                        </label>
                        <input
                          id="fileInput"
                          type="file"
                          name="attachment"
                          onChange={handleFileChange}
                          className="hidden"
                        />

                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-3">Required Response Date</label>
                      <input
                        type="date"
                        name="requiredResponseDate"
                        value={rfiData.requiredResponseDate}
                        onChange={handleChange}
                        required
                        onClick={(e) => e.target.showPicker()} // Ensures the calendar opens on click
                        className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-3">Reason for RFI</label>
                      <input
                        name="reasonForRFI"
                        value={rfiData.reasonForRFI}
                        onChange={handleChange}
                        required
                        className={`mt-1 bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}

                      />
                    </div>
                    <div className='col-span-3'>
                      <label className="block text-sm font-medium mb-3">Description</label>
                      <textarea
                        name="clarificationRequested"
                        value={rfiData.clarificationRequested}
                        onChange={handleChange}
                        required
                        className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}

                      />
                    </div>




                  </div>
                  <div className=" px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse justify-between">
                    <button
                      type="submit"
                      className={` py-2 px-4 rounded-md ${loading ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'} text-white text-md`}
                      disabled={loading}
                    >
                      {loading ? 'Submitting...' : 'Submit RFI'}
                    </button>
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:mt-0 sm:w-auto"
                      onClick={() => {
                        setOpen(false)
                      }}
                      ref={cancelButtonRef}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default RFIForm;
